"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchSubjectEventTypes = void 0;
var BranchSubjectEventTypes;
(function (BranchSubjectEventTypes) {
    BranchSubjectEventTypes["ADD"] = "branch-add";
})(BranchSubjectEventTypes || (exports.BranchSubjectEventTypes = BranchSubjectEventTypes = {}));
